import React, { useEffect, useRef } from 'react';
import * as UTIF from 'utif';

const TiffViewer = (base64String) => {
    const canvasRef = useRef(null);

    useEffect(() => {
			if (base64String && canvasRef.current) {
					// Decode base64 string to ArrayBuffer
					const binaryString = atob(base64String.data);
					const len = binaryString.length;
					const bytes = new Uint8Array(len);
					for (let i = 0; i < len; i++) {
							bytes[i] = binaryString.charCodeAt(i);
					}
					const arrayBuffer = bytes.buffer;

					// Decode TIFF using UTIF.js
					const ifds = UTIF.decode(arrayBuffer);
					UTIF.decodeImage(arrayBuffer, ifds[0]);
					const rgba = UTIF.toRGBA8(ifds[0]);

					// Render TIFF to canvas
					const canvas = canvasRef.current;
					const ctx = canvas.getContext('2d');
					const imageData = ctx.createImageData(ifds[0].width, ifds[0].height);
					imageData.data.set(rgba);
					canvas.width = ifds[0].width;
					canvas.height = ifds[0].height;
					ctx.putImageData(imageData, 0, 0);
			}
    }, [base64String]);

    return <canvas ref={canvasRef} />;
};

export default TiffViewer;
